// Webpack Imports
import * as bootstrap from 'bootstrap';

( function () {
	'use strict';

	// feather icons init
	feather.replace();

	if($('#page-header-slider').length>0){
		$('#page-header-slider').slick({
			arrows : false,
			dots : true,
			fade : true,
			autoplay: true,
  		autoplaySpeed: 5000,
		});
	}

	$('#navbar .menu-item').click(_=>{
		const bsCollapse = new bootstrap.Collapse('#navbar');
		bsCollapse.hide();
	})
	
} )();